<template lang="html">
  <div class="features">
    <h1 v-text="$ml.get('features.title')"/>
    <h3 v-text="$ml.get('features.subtitle')"/>
    <b-card-group deck>
      <b-card
        class="feature-card"
        :title="$ml.get('features.card_1.title')"
        img-src="static/img/features/logistics.jpg"
        align="center">
        <b-card-text v-for="i in $ml.get('features.card_1.text')" :key="i" v-text="i"/>
      </b-card>
      <b-card
        class="feature-card"
        :title="$ml.get('features.card_2.title')"
        img-src="static/img/features/delivery.jpg"
        align="center">
        <b-card-text v-for="i in $ml.get('features.card_2.text')" :key="i" v-text="i"/>
      </b-card>
      <b-card
        class="feature-card"
        :title="$ml.get('features.card_3.title')"
        img-src="static/img/features/production.jpg"
        align="center">
        <b-card-text v-for="i in $ml.get('features.card_3.text')" :key="i" v-text="i"/>
      </b-card>
    </b-card-group>
    <b-card-group class="mt-4" deck>
      <b-card
        class="feature-card"
        :title="$ml.get('features.card_4.title')"
        img-src="static/img/features/interactive-web.jpg"
        align="center">
        <b-card-text v-for="i in $ml.get('features.card_4.text')" :key="i" v-text="i"/>
      </b-card>
      <b-card
        class="feature-card"
        :title="$ml.get('features.card_5.title')"
        img-src="static/img/features/dynamic-mails.png"
        align="center">
        <b-card-text v-for="i in $ml.get('features.card_5.text')" :key="i" v-text="i"/>
      </b-card>
      <b-card
        class="feature-card"
        :title="$ml.get('features.card_6.title')"
        img-src="static/img/features/web-services.png"
        align="center">
        <b-card-text v-for="i in $ml.get('features.card_6.text')" :key="i" v-text="i"/>
      </b-card>
    </b-card-group>
    <b-card-group class="mt-4" deck>
      <b-card
        class="feature-card"
        :title="$ml.get('features.card_7.title')"
        img-src="static/img/features/controllo-qualita.jpg"
        align="center">
        <b-card-text v-for="i in $ml.get('features.card_7.text')" :key="i" v-text="i"/>
      </b-card>
      <b-card
        class="feature-card"
        :title="$ml.get('features.card_8.title')"
        img-src="static/img/features/permissions.jpg"
        align="center">
        <b-card-text v-for="i in $ml.get('features.card_8.text')" :key="i" v-text="i"/>
      </b-card>
      <b-card
        class="feature-card"
        :title="$ml.get('features.card_9.title')"
        img-src="static/img/features/eventi.jpg"
        align="center">
        <b-card-text v-for="i in $ml.get('features.card_9.text')" :key="i" v-text="i"/>
      </b-card>
    </b-card-group>
    <b-card-group class="mt-4" deck>
      <b-card
        class="feature-card"
        :title="$ml.get('features.card_10.title')"
        img-src="static/img/features/kpis-fwm.jpg"
        align="center">
        <b-card-text v-for="i in $ml.get('features.card_10.text')" :key="i" v-text="i"/>
      </b-card>
      <b-card
        class="feature-card"
        :title="$ml.get('features.card_11.title')"
        img-src="static/img/features/settimane.jpg"
        align="center">
        <b-card-text v-for="i in $ml.get('features.card_11.text')" :key="i" v-text="i"/>
      </b-card>
      <b-card
        class="feature-card"
        :title="$ml.get('features.card_12.title')"
        img-src="static/img/features/estrazioni.jpg"
        align="center">
        <b-card-text v-for="i in $ml.get('features.card_12.text')" :key="i" v-text="i"/>
      </b-card>
    </b-card-group>
    <b-card-group class="mt-4" deck>
      <b-card
        class="feature-card"
        align="center">
        <b-embed
          type="iframe"
          aspect="16by9"
          src="/static/vids/piattaforma_ot.mp4"
          allowfullscreen style="width:100%;left:0">
        </b-embed>
        <h4 class="mt-4 card-title" v-text="$ml.get('features.card_13.title')"/>
        <b-card-text v-for="i in $ml.get('features.card_13.text')" :key="i" v-text="i"/>
      </b-card>
      <b-card
        class="feature-card"
        :title="$ml.get('features.card_14.title')"
        img-src="static/img/shared/opentracking_logo.jpg"
        align="center">
        <b-card-text v-for="i in $ml.get('features.card_14.text')" :key="i" v-html="i"/>
        <b-button @click="jumpTo('/opentracking')" class="red-button" v-text="$ml.get('features.card_14.button')"/>
      </b-card>
      <b-card
        class="feature-card"
        :title="$ml.get('opentracking.card_3.title')"
        img-src="static/img/opentracking/plugin.jpg"
        align="center">
        <b-card-text v-for="i in $ml.get('opentracking.card_3.text')" :key="i" v-html="i"/>
        <a class="read-more" href="#paragraph" @click="goToPar(3)"
        v-text="$ml.get('opentracking.read_more')"
        v-show="$ml.get('opentracking.card_3.read_more')"/>
      </b-card>
    </b-card-group>
    <b-button v-show="showGoTop" id="goTopBtn" @click="goTop()">Top</b-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showGoTop: false
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll (event) {
      this.showGoTop = document.body.scrollTop > 400 || document.documentElement.scrollTop > 400
    },
    goTop () {
      window.scroll({top: 0, behavior: 'smooth'})
    },
    jumpTo (w) {
      this.$router.push(w)
    }
  }
}
</script>

<style lang="css" scoped>
div .features .card-deck {
  padding: 10px 55px;
}

.feature-card {
  -webkit-box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
  -moz-box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
  box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
  max-width: 30%;

  margin-left: 1.5%!important;
  margin-right: 1.5%!important;
}

@media only screen and (max-width: 1000px) {
  .feature-card {
    min-width: 100%;
    max-width: 100%;
  }
}

.card-text {
  text-align: left;
}

.red-button {
  background-color: #E0161A;
  color: #FDFDFD;
  border: none;
  outline: none;
  padding: .4rem 1.3rem;
}

.red-button:hover {
  background-color: #444;
}
</style>



// WEBPACK FOOTER //
// src/components/Features.vue